export default __webpack_public_path__ + "/dist/images/ai-powered-en.60edab3d05338e855ffcab17d8ae0fb9.jpg";